import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IFilesState {
  value: any[];
};

const initialState: IFilesState = {
  value: []
};

export const currentFilesSlice = createSlice({
  name: 'currentFiles',
  initialState,
  reducers: {
    setCurrentFiles: (state, action: PayloadAction<any[]>) => {
      state.value = action.payload;
    },
  },
});

export const { setCurrentFiles } = currentFilesSlice.actions;

export default currentFilesSlice.reducer;